const preservingScroll = new WeakSet<HTMLElement>()

export function isScrollPreservingFocus(target: HTMLElement) {
  return preservingScroll.has(target)
}

export function focusWithoutScroll(target: HTMLElement) {
  const alreadyPreserving = preservingScroll.has(target)
  preservingScroll.add(target)
  try {
    target.focus({ preventScroll: true })
  } finally {
    if (!alreadyPreserving) preservingScroll.delete(target)
  }
}
